import { useEffect, useState } from 'react';
import { RulingEphemerisData } from '../utils/kpRulingEphemeris';

type Request = { month: string; time: string; city: string; latitude: number; longitude: number; timezone: string; nodeMode: string; ayanamsha: string; useKpForNadiKp: boolean };
export function useKpRulingEphemeris(apiBaseUrl: string, token: string | null | undefined, request: Request, headers: Record<string, string>) {
  const [data, setData] = useState<RulingEphemerisData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const requestKey = JSON.stringify(request);
  const headerKey = JSON.stringify(headers);
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    setLoading(true); setError(''); setData(null);
    const params = new URLSearchParams();
    Object.entries(JSON.parse(requestKey)).forEach(([key, value]) => params.set(key, String(value)));
    fetch(`${apiBaseUrl}/charts/kp/ruling-ephemeris?${params}`, {
      headers: { ...JSON.parse(headerKey), ...(token ? { Authorization: `Bearer ${token}` } : {}) }, signal: controller.signal,
    }).then(async response => {
      const body = await response.json();
      if (!response.ok || !body.success || !body.data) throw new Error(body.message || 'Unable to load the ephemeris.');
      if (active) setData(body.data);
    }).catch(error => { if (active) setError(error.message || 'Unable to load the ephemeris.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [apiBaseUrl, token, requestKey, headerKey, revision]);
  return { data, loading, error, reload: () => setRevision(value => value + 1) };
}
